import * as React from "react";
import { Viewer, Worker } from "@react-pdf-viewer/core";
// import pdfFile from "../../public/10-K-2022.pdf";
// import pdfFile from "../../public/idea.pdf";

import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { searchPlugin } from '@react-pdf-viewer/search';
import { Icon } from '@react-pdf-viewer/core';



import {
  highlightPlugin,
  RenderHighlightTargetProps,
  Trigger,
} from "@react-pdf-viewer/highlight";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import "@react-pdf-viewer/highlight/lib/styles/index.css";


const PDFViewer = ({selectedPdf, keywords, scrollToKeyword, highlightPluginInstance, searchPluginInstance,  ...props}) => {

  // Defining state
  const [isDocumentLoaded, setDocumentLoaded] = React.useState(false);

  


  // const searchPluginInstance = searchPlugin({
  //     keyword: keywords ,
  // });

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    sidebarTabs: (defaultTabs) =>
        defaultTabs.concat({
            content: <div style={{ textAlign: 'center', width: '100%' }}>
                <ul>
               {keywords.map((keyword, index) => (
                  <li onClick={(e) => {
                    e.preventDefault();
                    scrollToKeyword(index);
                  }}
                  key = {index}
                  style={{"textAlign": "start", "cursor":"pointer"}}
                  >
                    Reference {index+1}
                  </li>
                  ))}
              </ul>
            </div>,
            icon: (
                <Icon size={16}>
                    <path d="M23.5,17a1,1,0,0,1-1,1h-11l-4,4V18h-6a1,1,0,0,1-1-1V3a1,1,0,0,1,1-1h21a1,1,0,0,1,1,1Z" />
                    <path d="M5.5 12L18.5 12" />
                    <path d="M5.5 7L18.5 7" />
                </Icon>
            ),
            title: 'References',
        }),
});

// const { toolbarPluginInstance } = defaultLayoutPluginInstance;
// const { highlight } = searchPluginInstance;

  //   React.useEffect(() => {
  //     if (isDocumentLoaded) {
  //         highlight(keywords);
  //     }
  // }, [isDocumentLoaded]);

  // const renderHighlights = (props) => (
  //   React.createElement('div', null,
  //     areas
  //       .filter((area) => area.pageIndex === props.pageIndex)
  //       .map((area, idx) =>
  //         React.createElement('div', {
  //           key: idx,
  //           className: 'highlight-area',
  //           style: Object.assign(
  //             {},
  //             {
  //               background: 'yellow',
  //               opacity: 0.4,
  //             },
  //             props.getCssProperties(area, props.rotation)
  //           ),
  //         })
  //       )
  //   )
  // );

  // const highlightPluginInstance = highlightPlugin({
  //   renderHighlights,
  //   trigger: Trigger.None,
  // });

  const handleDocumentLoad = () => setDocumentLoaded(true);

  // const scrollToKeyword = (keywordIndex) => {

  //   console.log("inside scrollToKeyword")
  //   const result =highlight(keywords[keywordIndex]);
  //   console.log("result", result)
  //   // const { jumpToDestination } = searchPluginInstance;
  //   // const keyword = keywords[keywordIndex];
  //   // const result = jumpToDestination(keyword);
  //   // if (result) {
  //   //   // Scroll to the destination
  //   //   result.pageNumber !== null && result.pageNumber !== undefined &&
  //   //     result.pageNumber >= 0 &&
  //   //     result.pageNumber < result.doc.numPages &&
  //   //     result.doc.setPage(result.pageNumber + 1);
  //   //   result.destArray !== null && result.destArray !== undefined &&
  //   //     result.destArray.length > 0 &&
  //   //     jumpToDestination(result.destArray[0]);
  //   // }
  // };


  return (
    <div style={{
      height: "95vh",
      maxWidth: "900px",
      marginLeft: "auto",
      marginRight: "auto"
    }}>
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.js">
      <Viewer theme="dark" fileUrl={selectedPdf?.pdfLink} plugins={[defaultLayoutPluginInstance, highlightPluginInstance, searchPluginInstance]}  onDocumentLoad={handleDocumentLoad}/>
    </Worker>
    </div>
    
  );
};

export default PDFViewer;
